import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import NotFound from "./pages/NotFound";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import About from "./components/About";
import Career from "./components/Career";
import Projects from "./components/Projects";
import Skills from "./components/Skills";

const router = createBrowserRouter([
    {
        path: "/",
        element: <App />,
        errorElement: <NotFound />,
        children: [
            {
                index: true,
                path: "/about",
                element: <About />,
                errorElement: <NotFound />,
            },
            {
                path: "/career",
                element: <Career />,
                errorElement: <NotFound />,
            },
            {
                path: "/projects",
                element: <Projects />,
                errorElement: <NotFound />,
            },
            {
                path: "/skills",
                element: <Skills />,
                errorElement: <NotFound />,
            },
        ],
    },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>
);
